import React from "react";
import { Input, Button, UncontrolledTooltip,FormGroup,Form,Col,Label } from "reactstrap";
import Filter from "./Filter";
import LessonCard from "./LessonCard";
//import { uniqBy } from 'lodash';

export default class EditNodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      allNodes: [
        { lessonId: "02", name: "Oops" },
        { lessonId: "03", name: "Node1" },
        { lessonId: "05", name: "Dracula" },
        { lessonId: "02", name: "Zakata" },
        { lessonId: "01", name: "abc" },
        { lessonId: "01", name: "sdf" },
        { lessonId: "01", name: "sdsf" },
        { lessonId: "01", name: "Challenger" },
        { lessonId: "01", name: "mastery" },
        { lessonId: "01", name: "asd" },
        { lessonId: "01", name: "asdfsa" }
      ]
    };
    this.clearFilter = this.clearFilter.bind(this);
    this.toggleNode = this.toggleNode.bind(this);
  }

  toggleNode(nodeName) {
    let newList = [];
    this.state.allNodes.map(value => {
      if (value.name === nodeName) {
        if (value.lessonId === "01") {
          value.lessonId = "02";
        } else {
          value.lessonId = "01";
        }
      }
      newList.push(value);
    });
    this.setState({ allNodes: newList });
  }
  updateNodes() {
    let updatedNodes = [];
    this.state.allNodes.map(value => {
      if (value.lessonId === "01") {
        updatedNodes.push(value);
      }
    });
    this.props.onUpdateNodes(updatedNodes);
  }
  onChg = ({ target }) => this.setState({ [target.name]: target.value });
  clearFilter() {
    this.setState({ filter: "" });
  }
  render() {
    const filterRule = st =>
      st.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1;
    //const Nodes = uniqBy(nodes, 'lessonId')// ["Oops", "Node1", "Dracula", "Zakata","abc", "sdf", "sdsf", "Challenger", "mastery", "asd", "asdfsa"]; //uniqBy(users, 'id')
    const filteredNodes = this.state.allNodes.filter(filterRule);

    return (
      <React.Fragment>
        <LessonCard
          iconClass="node-white"
          heading="Edit Nodes"
          subHeading={`Select or unselect knowledge map nodes to associate with the ${this.props.name} ${this.props.type}.`}
          isCollapsable={false}
          footerButtons={[
            <Button
              className="lesson-cancle-btn"
              onClick={() => this.props.closeEditNode("editNode")}
            >
              Cancel Changes
            </Button>,
            <Button
              className="lesson-action-btn"
              onClick={() => this.updateNodes()}
            >
              Update Nodes
            </Button>
          ]}
        >
          <Filter
            onChg={this.onChg}
            filter={this.state.filter}
            placeholder={"Search"}
            clearFilter={this.clearFilter}
          />
          <div className="add-deck-scrollview">
{filteredNodes.map((value, index) => {
  return (
    <React.Fragment key={index}>
     <Form inline>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 rules-item">
              <div className='author-lesson-checkbox'>
                  <Input type="checkbox" checked={(value.lessonId === "01")?true:false} onChange={(e) => this.toggleNode(value.name)}/>
                  <span className="checkmark"></span>
              </div>
              <Label id={`rule_threshold_item-right-${index}`} for="rule_threshold" >{value.name} </Label>
              <UncontrolledTooltip placement="bottom" target={`rule_threshold_item-right-${index}`} style={{backgroundColor: '#4C4C4C'}}>
                  Node description...
              </UncontrolledTooltip>
          </FormGroup>
      </Form>
    </React.Fragment>
  );
})}
           </div> 
          
        </LessonCard>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/EditNodes.js